<template>
<!-- 逾期记录 -->
  <div class="page flex componentPage">
      <el-form :inline="true" :model="form" class='flexForm'>
            <el-form-item>
                <el-input placeholder="请输入手机号或客户姓名" v-model="form.userNameOrPhone "></el-input>
            </el-form-item>
            <el-form-item>
                <el-input placeholder="请输入订单编号" v-model="form.keyWord"></el-input>
            </el-form-item>
            <!-- <el-form-item label=" ">
                <el-select v-model="form.orderStatus" clearable placeholder="订单状态">
                    <el-option v-for="item in getOrderStatus" :key="item.codeKey" :label="item.codeKey" :value="item.codeValue"></el-option>
                </el-select>
            </el-form-item> -->
            <el-form-item label=" ">
                <el-date-picker placeholder="请选择计划还款开始时间" v-model="form.begin" type='date' format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label=" ">
                <el-date-picker placeholder="请选择计划还款结束时间" v-model="form.end" type='date' format="yyyy-MM-dd" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="buttonTeam floatNone">
                <el-button type="primary" @click="getUser" icon='el-icon-search'></el-button>
            </el-form-item>
        </el-form>
        <!-- <el-col :span='4'><el-button type="primary" @click="add">添加</el-button></el-col> -->
        <el-table :data='dataList' border height="100%" v-loading='tableLoading'>
            <el-table-column type='index'  label='序号' width="60"></el-table-column>
            <el-table-column prop="orderNo" label="订单编号" v-slot='{row}' width='200'>
                <span class='spans'>{{row.record.orderNo}}</span>
            </el-table-column>
            <!-- <el-table-column prop="orderStatus" label="订单状态">
                <template slot-scope='{row}' v-if='getOrderStatus.length>0'>{{checkOrderStatus(row.orderStatus).codeKey}}</template>
            </el-table-column> -->
                <el-table-column prop="userName" label="客户姓名" width='100'/>
                <el-table-column prop="mobile" label="手机号" width='115'/>
                <el-table-column prop="period" label="期数" width='100'>
                    <template v-slot='{row}'>
                        {{row.record.period}}
                    </template>
                </el-table-column>
                <el-table-column prop="planRepayCapital" label="本金" width='100'>
                    <template v-slot='{row}'>
                        {{row.record.planRepayCapital}}
                    </template>
                </el-table-column>
                <el-table-column prop="planRepayInterest" label="利息" width='100'>
                    <template v-slot='{row}'>
                        {{row.record.planRepayInterest}}
                    </template>
                </el-table-column>
                <el-table-column prop="planRepayInterest" label="逾期金额" width='100' v-slot='{row}'>
                    {{$tools.math.add(row.record.planRepayInterest,row.record.planRepayCapital)}}
                </el-table-column>
                <!-- <el-table-column prop="period" label="申请期数" width='80'/> -->
                <el-table-column prop="createDate" label="计划还款时间" width='170'>
                    <template v-slot="{row}">{{$date.format(row.record.planRepayDate, "YYYY-MM-DD HH:mm:ss")}}</template>
                </el-table-column>
                <el-table-column prop="overdueDays" label="逾期天数" v-slot='{row}' width='100'>
                    {{parseInt((new Date().getTime() - new Date(row.record.planRepayDate).getTime()) / 1000 / 60 / 60 / 24)}}
                </el-table-column>
                <el-table-column prop="channelName" label="罚息" v-slot='{row}' width='100'>
                    {{payMuch(row)}}
                </el-table-column>
                <el-table-column prop="channelName" label="还款状态" width='100'>
                    逾期
                </el-table-column>
                <el-table-column prop="channelName" label="冻结状态" v-slot='{row}' width='100'>
                    <span v-if='row.record.frozen' style='color: red;'>已冻结</span>
                    <span v-else style='color:#409EFF;'>未冻结</span>
                </el-table-column>
                <el-table-column prop="channelName" label="操作" fixed='right' width='380' align="center">
                    <template slot-scope='{row}'>
                        <el-button  type='warning' size='mini' @click.stop="openhisttory(row)">催收历史</el-button>
                        <!-- <el-button  type='warning' size='mini' @click.stop="addhisttory(row)">新增催收历史</el-button> -->
                        <el-button  type='warning' size='mini'>手动扣款</el-button>
                        <el-button  type='warning' size='mini' @click="underline(row)">线下扣款</el-button>
                        <el-button  type='error' size='mini' @click.stop='codeFroze(row)'>冻结逾期</el-button>
                    </template>
                </el-table-column>

        </el-table>
        <!-- <overtd href='131231' v-slot={href}>{{href}}</overtd> -->
        <div class='tablepage'>
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-size='pageSize'
            @current-change='getUser'
            :page-sizes="[10,20,30,40]"
            @size-change='sizeChange'
            :current-page.sync="current"
            :total="total">
        </el-pagination>
      </div>
        <el-dialog title='催收记录' :visible.sync="visible" width="80%">
          <collection-history :params='params' :close='close'/>
      </el-dialog>
      <!-- <el-dialog title='新增催收记录' :visible.sync="visible2" width="50%">
          <add-overdue :params='params2' :close='close'/>
      </el-dialog> -->
  </div>
</template>

<script>
import collectionHistory from '@/components/collectionHistory.vue'
// import addOverdue from '@/components/addOverdue.vue'
import { mapGetters } from 'vuex'
  export default {
    data () {
      return {
          form: {},
          dataList: [],
          title: '新增用户',
          visible: false,
          visible2: false,
          params: {},
          params2: {},
          orderStatus: [
              
          ],
          roleNames:[],
          current:1,
          total: 0,
          pageSize: 10,
          tableLoading:false
      }
    },
    computed:{
        ...mapGetters([
            'getOrderStatus',
            'checkOrderStatus'
        ])
    },
    components: {
        collectionHistory
    },
   methods: {
       async getUser(){
           this.tableLoading = true
           let params = {
               ...{current:this.current,pageSize:this.pageSize,repayStatus:3},
               ...this.form
           }
           const rsp = await this.$http.overdue(params)
           this.tableLoading = false
           if(rsp.code != 200) return
           this.dataList = rsp.data.data
           this.total = rsp.data.total
           
       },
       sizeChange(val){
           this.pageSize = val
           this.getUser()
       },
       close(){
           this.visible = false
           this.getUser()
       },
       add(){
           this.params = {}
           this.visible = true
           this.title = '新增用户'
           this.params = {}
       },
       payMuch(row){
           var now = new Date();
            var planRepayDate = new Date(row.record.planRepayDate);
            var day = parseInt((now.getTime() - planRepayDate.getTime()) / 1000 / 60 / 60 / 24);
            var amt = parseFloat(row.record.planRepayCapital) + parseFloat(row.record.planRepayInterest);
            var num = parseFloat(day * 0.0003 * amt)
            var res = new Number(num);
            return res.toFixed(2);
       },
       //查看催收历史
       openhisttory(row){
           this.visible = true
           this.params = row
       },
       addhisttory(row){
           this.visible2 = true
           this.params2 = row
       },
       async forze(row){
           let params = {
               orderNo: row.record.orderNo,
               period: row.record.period
           }
           const rsp = await this.$http.codeFroze(params)
           if(rsp.code != 200) return
           this.$message({type:'success',message: rsp.message})
           this.getUser()
       },
       //冻结逾期
       codeFroze(row){
           this.$confirm('是否冻结该笔逾期?','提示',{
               type:'warning',
               confirmButtonText: '确定',
               cancelButtonText: '取消'
           }).then(res=>{
               this.forze(row)
           }).catch(()=>{

           })
       },
       //扣款操作
       async repayOffline(row){
           const params = {
               orderNo: row.record.orderNo,
               period: row.record.period
           }
           const rsp = await this.$http.repayOffline(params)
           if(rsp.code != 200) return this.$message({message:rsp.message,type:'error'})
           this.$message({message:rsp.message,type:'success'})
           this.getUser()
       },
       //线下扣款
       async underline(row){
           this.$confirm('是否确认下线收款?','提示',{
               type:'warning',
               confirmButtonText: '确定',
               cancelButtonText: '取消'
           }).then(res=>{
               this.repayOffline(row)
           }).catch(()=>{
               
           })
       }
   },
   created(){
       this.getUser()
   }
    }
</script>

<style scoped >
.page{flex-direction: column;}
 
</style>
